var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 11.7347H1.75V33.2104H33.25V11.7347Z",
    fill: "#D6D6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7501 0H5.25007L0 9.60018V11.5202C0 12.5806 1.56695 13.4402 3.49996 13.4402C5.43297 13.4402 6.99992 12.5806 6.99992 11.5202C6.99992 12.5806 8.56687 13.4402 10.4999 13.4402C12.4329 13.4402 13.9998 12.5806 13.9998 11.5202C13.9998 12.5806 15.5668 13.4402 17.4998 13.4402C19.4328 13.4402 20.9998 12.5806 20.9998 11.5202C20.9998 12.5806 22.5667 13.4402 24.4997 13.4402C26.4327 13.4402 27.9997 12.5806 27.9997 11.5202C27.9997 12.5806 29.5668 13.4402 31.4996 13.4402C33.4325 13.4402 34.9996 12.5806 34.9996 11.5202V9.60018L29.7501 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25007 0L0 9.60018V11.5202C0 12.5806 1.56695 13.4402 3.49996 13.4402C5.43297 13.4402 6.99992 12.5806 6.99992 11.5202V9.60018L10.5 0H5.25007Z",
    fill: "#E66969"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00006 9.60016V11.5202C7.00006 12.5806 8.56701 13.4402 10.5 13.4402C12.433 13.4402 14 12.5806 14 11.5202V9.60016H7.00006Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.60016V11.5202C21 12.5806 22.5669 13.4402 24.5 13.4402C26.433 13.4402 27.9999 12.5806 27.9999 11.5202V9.60016H21Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1251 0H14.8751L14 9.60018V11.5202C14 12.5806 15.5669 13.4402 17.5 13.4402C19.433 13.4402 20.9999 12.5806 20.9999 11.5202V9.60018L20.1251 0Z",
    fill: "#E66969"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7501 0H24.5L28 9.60018V11.5202C28 12.5806 29.567 13.4402 31.4999 13.4402C33.4328 13.4402 34.9999 12.5806 34.9999 11.5202V9.60018L29.7501 0Z",
    fill: "#E76969"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6876 16.1578H4.81256V27.7905H19.6876V16.1578Z",
    fill: "#FDFDFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 17.0527H5.6875V26.8957H18.8125V17.0527Z",
    fill: "#C3EFEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 20.2081L11.5751 17.0527H13.1601L5.6875 21.067V20.2081Z",
    fill: "#DCF3F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 21.6137L14.1926 17.0527H14.8576L5.6875 21.9741V21.6137Z",
    fill: "#DCF3F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 22.4728L15.7851 17.0527H16.6075L5.6875 22.9265V22.4728Z",
    fill: "#DCF3F3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 33.2104H1.75V35H33.25V33.2104Z",
    fill: "#B6B6B6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1877 16.1578H22.3127V33.2105H30.1877V16.1578Z",
    fill: "#FDFDFD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3126 17.1609H23.1876V32.2073H29.3126V17.1609Z",
    fill: "#C3EFEF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1876 24.2366H22.3126V25.1315H30.1876V24.2366Z",
    fill: "#FDFDFD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1876 29.489L29.3127 26.2067V27.0573L23.1876 30.3478V29.489Z",
    fill: "#DCF3F3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1876 30.8945L29.3127 27.6097V27.9677L23.1876 31.255V30.8945Z",
    fill: "#DCF3F3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1876 31.7535L29.3127 28.4657V28.9126L23.1876 32.2072V31.7535Z",
    fill: "#DCF3F3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5585 25.5113C23.7636 25.3016 23.7636 24.9616 23.5585 24.7519C23.3535 24.5422 23.021 24.5422 22.816 24.7519C22.6109 24.9616 22.6109 25.3016 22.816 25.5113C23.021 25.721 23.3535 25.721 23.5585 25.5113Z",
    fill: "#364251"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.217ab36b7fd894e8d8070aec7d26a4b6.svg";
export { ForwardRef as ReactComponent };